import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-entrustHomeB",
  "use": "icon-entrustHomeB-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-entrustHomeB\"><defs><style type=\"text/css\"></style></defs><path d=\"M24.380952 292.571429h975.238096v731.428571H24.380952V292.571429z m162.523429 162.523428v68.266667h650.191238v-68.266667H186.904381z m0 162.572191v68.266666h650.191238v-68.266666H186.904381z m0 162.523428v68.266667h650.191238V780.190476H186.904381z\" fill=\"#0099FF\" p-id=\"6320\" /><path d=\"M512 48.761905l390.095238 292.571428H121.904762l390.095238-292.571428z m-3.413333 87.868952L310.418286 292.571429h398.189714l-199.92381-155.940572z\" fill=\"#0099FF\" p-id=\"6321\" /><path d=\"M509.318095 105.130667m-73.142857 0a73.142857 73.142857 0 1 0 146.285714 0 73.142857 73.142857 0 1 0-146.285714 0Z\" fill=\"#0099FF\" p-id=\"6322\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/entrustHomeB.svg
// module id = Elz0
// module chunks = 81